import { Component, computed, input, NgZone, OnChanges, output, Signal } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
    selector: 'pp-point-reminder-modal-end-date-picker',
    templateUrl: './point-reminder-modal-end-date-picker.component.html',
    styleUrl: './point-reminder-modal-end-date-picker.component.scss',
    standalone: false
})
export class PointReminderModalEndDatePickerComponent implements OnChanges {
  ppEndDate = input<number>();
  ppEndDateChange = output<number>();
  ppMinDate = input<Date>();
  ppDisabled = input<boolean>();
  showDateWarning: Signal<boolean> = computed(() =>
    this.checkIfEndDateIsTooFarInFuture(this.ppEndDate()),
  );
  ppScrollToBottom = output<void>();
  doesNotRepeat: boolean;

  tooFarInFutureBackup = false; // Backup for the warning message
  EIconPath = EIconPath;

  constructor(private ngZone: NgZone) {}

  ngOnChanges(): void {
    this.doesNotRepeat = !this.ppEndDate();
  }

  removeEndDate(): void {
    if (this.ppDisabled()) {
      return;
    }

    this.ppEndDateChange.emit(null);
    this.doesNotRepeat = true;
  }

  allowSettingEndDate(): void {
    if (this.ppDisabled()) {
      return;
    }

    this.doesNotRepeat = false;

    this.ppEndDateChange.emit(this.getEpochOfDayYearFromNow());
  }

  onEndDateChange(dates: Date[]): void {
    this.ppEndDateChange.emit(dates[0].getTime());
  }

  private getEpochOfDayYearFromNow(): number {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);
    return date.getTime();
  }

  private checkIfEndDateIsTooFarInFuture(endDate: number): boolean {
    if (!endDate) {
      return true;
    }

    const currentDate = new Date();
    const threeYearsFromNow = new Date(currentDate);
    threeYearsFromNow.setFullYear(currentDate.getFullYear() + 3);

    const isTooFarInTheFuture = endDate > threeYearsFromNow.getTime();

    if (isTooFarInTheFuture !== this.tooFarInFutureBackup) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ppScrollToBottom.emit();
        }, 100);
      });
    }

    this.tooFarInFutureBackup = isTooFarInTheFuture;

    return isTooFarInTheFuture;
  }
}
